export default __webpack_public_path__ + "images/6W.24a44cb.png";